import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BusyState {
  workspaceId?: string;
  threadId?: string;
}

interface DemandGenSliceState {
  busy: BusyState | null;
}

const initialState: DemandGenSliceState = {
  busy: null,
};

export const demandGenSlice = createSlice({
  name: 'demandGen',
  initialState,
  reducers: {
    setBusy(state, action: PayloadAction<BusyState>) {
      state.busy = action.payload;
    },
    clearBusy(state) {
      state.busy = null;
    },
  },
});

export const { setBusy, clearBusy } = demandGenSlice.actions;
